export default __webpack_public_path__ + "static/media/footer-email-ICN.388ab0ab.svg";